import Marquee from "react-fast-marquee";
import { Plus } from "lucide-react";
import { VALUES } from "../../data/content";

export const ValuesMarquee = () => (
  <div data-testid="values-marquee" className="border-y border-navy bg-navy py-6 overflow-hidden">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {VALUES.map((v) => (
        <span key={v} className="flex items-center gap-8 mx-8">
          <span className="font-display font-bold text-2xl md:text-3xl tracking-tight text-white/90 whitespace-nowrap">
            {v}
          </span>
          <Plus size={20} className="text-brand shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);
